<template>
  <div :class="t" class="indicator t-small">
    {{ t_fixed }}
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  props: ["data"],
  computed: {
    ...mapState({
      period: (state) => state.config.periods.machines,
    }),
    t_used() {
      switch (this.period) {
        case "shift":
          return this.data.tak_percent_shift;
          break;
        case "24h":
          return this.data.tak_percent_24;
          break;
        case "today":
          return this.data.tak_percent_today;
          break;
        case "calendar":
          return this.data.tak_percent_calendar;
          break;
      }
    },
    t_fixed() {
      if (this.t_used > 100) {
        return Math.floor(this.t_used);
      }
      return this.t_used;
    },
    t() {
      if (+this.t_used === 0) {
        return "c-gray";
      } else if (+this.t_used >= +this.data.oee_green_limit) {
        return "c-green";
      } else if (+this.t_used >= +this.data.oee_yellow_limit) {
        return "c-yellow";
      } else return "c-red";
    },
  },
};
</script>